import BaseButton from "base/BaseButton";
import DonutChart from "react-donut-chart";
import React, { useMemo } from "react";
import RecipeMacros from "./RecipeMacros";
import "./RecipeServingInfo.css";

const RecipeServingInfo = ({ recipe, servings, setServings }) => {
  const reactDonutChartData = useMemo(() => {
    return (
      recipe.macros?.map((macro) => ({
        label: macro.label,
        value: macro.percentage,
      })) || []
    );
  }, [recipe.macros]);

  const reactDonutChartBackgroundColor = useMemo(() => {
    return recipe.macros?.map((macro) => macro.color) || [];
  }, [recipe.macros]);
  
  return (
    <>
      <section>
        <h6 className="Row A-Center Justify-Center">Servings</h6>
        <div className="Row A-Center Serving-Controls">
          <BaseButton
            buttonClass="Serving-Control-Button"
            buttonText="-"
            handleClick={() =>
              setServings((currentServings) => Math.max(1, currentServings - 1))
            }
          />
          <p className="Serving-Count">{servings}</p>
          <BaseButton
            buttonClass="Serving-Control-Button"
            buttonText="+"
            handleClick={() =>
              setServings((currentServings) => currentServings + 1)
            }
          />
        </div>
      </section>

      {recipe?.calories && recipe?.calories > 0 && recipe.macros?.length > 0 ? (
        <section>
          <div className="Row Space-E marg-t-1">
            <div className="Column A-Center">
              <h6>Calories</h6>
              <p>{recipe?.calories}</p>
            </div>
            <div className="Column A-Center">
              <h6>Macros</h6>
              <div className="Row">
                <div className="Column marg-left-5">
                  <DonutChart
                    width={50}
                    height={50}
                    strokeColor="#FFFFFF"
                    data={reactDonutChartData}
                    colors={reactDonutChartBackgroundColor}
                    innerRadius={0.7}
                    selectedOffset={0.4}
                    legend={false}
                    interactive={false}
                  />
                </div>
                <div className="Column marg-left-5">
                  {recipe.macros?.map((macro) => {
                    return <RecipeMacros key={macro.label} macro={macro} />;
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
};

export default RecipeServingInfo;
